import styled from 'styled-components';

export const SimpleVR = styled.div`
    height: 30px;
    border-left: 1px solid #bccacb;
    opacity: 0.2;
`;

export default SimpleVR;
